import { FC, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorType, logError } from '../../../utils/splunkLogger';
import { FallBackComponent } from './FallbackComponent';

type AreaWidgetErrorBoundaryProps = PropsWithChildren<{
  widgetName: string;
}>;

export const AreaWidgetErrorBoundary: FC<AreaWidgetErrorBoundaryProps> = ({ children, widgetName }) => {
  return (
    <ErrorBoundary
      FallbackComponent={FallBackComponent}
      onError={(error, componentStack) => {
        logError({
          error,
          errorType: ErrorType.WIDGET_ERROR_BOUNDARY,
          info: { componentStack, widgetName },
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
